import { render, staticRenderFns } from "./qiweiMiniGame.vue?vue&type=template&id=80fff8be&scoped=true"
import script from "./qiweiMiniGame.vue?vue&type=script&lang=js"
export * from "./qiweiMiniGame.vue?vue&type=script&lang=js"
import style0 from "./qiweiMiniGame.vue?vue&type=style&index=0&id=80fff8be&prod&lang=scss"
import style1 from "./qiweiMiniGame.vue?vue&type=style&index=1&id=80fff8be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fff8be",
  null
  
)

export default component.exports